import Navbar from "@/components/kenjosset/Navbar"
import Flash from "@/components/kenjosset/Flash"
import Footer from "@/components/kenjosset/Footer"
import ContactForm from "@/components/kenjosset/ContactForm"
import type { KenjossetChrome } from "@/components/kenjosset/types"

interface Props {
  chrome: KenjossetChrome
  aboutHtml: string
  portraitSrc: string
}

// Faithful React port of kenjosset/about.html.slim: the store's ActionText
// "about" body next to the portrait, then the same contact form as /contact.
export default function About({ chrome, aboutHtml, portraitSrc }: Props) {
  return (
    <div className="bg-light min-h-screen">
      <Navbar chrome={chrome} active="about" />

      <div className="min-h-[calc(100vh-500px)] h-full">
        <div className="max-w-7xl mx-auto flex flex-col items-center md:flex-row w-full pt-12 mb-10 px-6">
          <div
            className="w-full md:pl-0 md:pr-6 pt-6 md:pt-0 text-justify text-contrast font-kenjosset"
            dangerouslySetInnerHTML={{ __html: aboutHtml }}
          />
          <div className="pt-6 md:pt-0 w-full">
            <img src={portraitSrc} alt="" className="object-contain overflow-hidden" />
          </div>
        </div>

        <div className="max-w-7xl mx-auto flex flex-col items-center md:flex-row w-full pt-12 mb-10 px-6">
          <div className="w-full">
            <div className="text-2xl font-bold mb-6">Une idée de projet ? Contactez-moi !</div>

            <ContactForm formClassName="w-full" submitClassName="btn btn-primary ml-auto block" />
          </div>
        </div>
      </div>

      <Footer chrome={chrome} />
      <Flash />
    </div>
  )
}
